import { Component, OnInit } from '@angular/core';
import { AdminService } from '../../../services/core.admin.service';
import { StateService } from '@uirouter/angular';

import * as _ from 'lodash';

@Component({
    selector: 'project-trove',
    template: require('./project.trove.component.html')
})
export class ProjectTroveComponent implements OnInit {

    protected categories = [];
    protected currentCategory = null;

    protected treeOptions: any = {
        displayField: 'title',
        idField: 'id',
        childrenField: 'nodes',
        onSelectItem: (node) => {
            this.openCategory(node);
        }
    };

    constructor(
        private stateService: StateService,
        private adminService: AdminService,
    ) { }

    ngOnInit() {
        this.adminService.troveCategories()
        .then((ret: any) => {
            this.categories = [this.createCategoryTree(ret.items, this.stateService.params.selected)];
            // if (this.currentCategory) this.setCurrentCategory(this.currentCategory);
            this.treeOptions.selectedItem = this.currentCategory;
        });
    }

    buildCategoryPath(category) {
        var _path = [];
        _.each(category.categoryPath, function (item) {
            if (!item.isRoot) {
                _path.push(item.title);
            }
        });

        return _path.join('/');
    }

    toggleCollapse(node) {
        node.expanded = !node.expanded;
    }

    openCategory(category) {
        this.setCurrentCategory(category);
        this.stateService.go(
            '.', { selected: category.id }
        );
    }

    setCurrentCategory(category) {
        console.log("setCurrentCategory", category);
        _.each(category.categoryPath, function (node) {
            node.expanded = true;
        });

        this.currentCategory = category;
        return category;
    }

    createCategoryTree(items, selectedId = 0) {
        var _categories = _.cloneDeep(items),
            rootCategory = _.remove(_categories, { id: 0 }), //Find incoming (root) category
            rootNode;

        if (rootCategory?.length > 0) {
            rootNode = this.createCategoryNode(rootCategory[0], true, 0);
        } else {
            rootNode = this.createRootNode();
        }

        rootNode.categoryPath = [rootNode];
        rootNode.nodes = this.createCategorySubTree(0, _categories, 1, rootNode.categoryPath, selectedId);
        if (!this.currentCategory) {
            this.setCurrentCategory(rootNode);
        }
        return rootNode;
    }

    createCategorySubTree(parentCategoryId, categorys, level, categoryPath, selectedId) {
        var nodes = [],
            children = _.filter(categorys, { parentCategoryId: parentCategoryId }),
            node, _categoryPath;

        children.forEach((category) => {
            _categoryPath = [];
            _.each(categoryPath, (node) => {
                _categoryPath.push(node);
            });
            node = this.createCategoryNode(category, false, level);
            if (selectedId == node.id) {
                this.currentCategory = node;
            }
            _categoryPath.push(node);
            node.categoryPath = _categoryPath;
            node.nodes = this.createCategorySubTree(category.id, categorys, level + 1, _categoryPath, selectedId);
            if (node.id == this.stateService.params.selected) {
                this.setCurrentCategory(node);
            }
            nodes.push(node);
        });

        nodes = _.sortBy(nodes, function (node) {
            return node.title.toLowerCase();
        });

        return nodes;
    }

    createRootNode() {
        return this.createCategoryNode({
            id: 0,
            isPublic: 'Y',
            isSet: true,
            isMonitored: false
        }, true, 0);
    }

    createCategoryNode(category, isRoot, level) {
        return {
            id: category.id,
            title: ((isRoot) ? 'Root' : category.categoryName),
            nodes: [],
            isPublic: (category.isPublic == 'Y') ? true : false,
            parentCategoryId: (isRoot) ? -1 : category.parentCategoryId,
            isRoot: (isRoot) ? true : false,
            isSet: category.isSet,
            level: level,
            expanded: isRoot,
            isMonitored: category.isMonitored,
            category: category
        };
    }
}